import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import RecrutiConHead from "../components/RecruitConHead";
import RecrutiCon from "../components/RecruitCon";
import Cta from "../components/Cta";
import SimpleTags from "../components/SimpleTags";

import Hero from "../components/Heros/HeroRecruit";

const RecruitPage = () => (
    <>
        <Seo
            title="팀 문화"
            description="KUSRC는 일에 더 몰입하고 성장할 수 있도록 지원합니다. 자율적인 근무 환경과 교육·복지 제도를 소개합니다."
            path="/recruit"
        />
        <Hero />
        <RecrutiConHead />
        <RecrutiCon />
        <SimpleTags />
        <Cta preset="recruit" imageSrc="/img/team-overview.jpg" />
        <Footer />
    </>
);

export default RecruitPage;
